<ngx-spinner
        bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false"
    >
    <p class="loading">{{'general.processing' | translate}}...</p>
</ngx-spinner>

<div *ngIf="cart!=null">
    <form [formGroup]="buySubscriptionForm" name="form" (ngSubmit)="buySubscription()" class="w-100">
        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-2">
                
                <div class="card border-top">
                    <div class="card-body">
                        <h4>{{'account.subscription_purchase' | translate}}</h4>
                        <hr>
                        <div class="row">
                            <div class="col-2 d-none d-sm-block">
                                <img src="assets/images/sa-icon.png" class="rounded" alt="{{'alt.sa_logo' | translate}}">
                            </div> 
                            <div class="col-xs-12 col-sm-10">
                                <h4>Contigo MSJ - 
                                    <span class="text-nowrap">{{cart["planName"] | translate}}</span>&nbsp;&nbsp;
                                    <a tabindex="0" class="h6 custom-hyperlink" (keydown.enter)="changePlan(false)" (click)="changePlan(true)"><u>{{'account.change_plan' | translate}}</u></a>
                                </h4>
                                <div>
                                    {{cart.planDescription}}
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <strong>{{ "roles.agents_supervisors" | translate }}:</strong>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <p>{{ cart?.planAgentsSupervisors }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <strong>{{ "roles.users" | translate }}:</strong>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <p>{{ cart?.planUsers }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <strong>{{ "plan.video_feature" | translate }}:</strong>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <p>{{ (cart?.planIncludesVideo?'general.yes':'No') | translate }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <strong>{{ "plan.agent_dispatch" | translate }}:</strong>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <p>{{ (cart?.planAgentDispatch?'general.yes':'No') | translate }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-md-6">
                                        <strong>{{ "plan.geo_zone_assignment" | translate }}:</strong>
                                    </div>
                                    <div class="col-xs-12 col-md-6">
                                        <p>{{ (cart?.planGeoAssignment?'general.yes':'No') | translate }}</p>
                                    </div>
                                </div>
                                <div class="small">
                                    {{'account.renew_details' | translate}}
                                </div>
                                <hr>
                                <strong>{{'account.card_information' | translate}}:</strong><br><br>
                                    <fieldset>
                                        <legend class="h6"><strong>{{'account.billing_cycle' | translate}}<span class="error">*</span>: </strong></legend>
                                        <label class="radio-inline pr-1">
                                            <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="M" (click)="getBillingQuantity('M')" [(ngModel)]="model.options">&nbsp;{{'account.monthly' | translate}}
                                        </label>
                                        <label class="radio-inline pr-1 pl-1">
                                            <input type="radio" name="BillingCycle" formControlName="BillingCycle" value="Y" (click)="getBillingQuantity('Y')" [(ngModel)]="model.options" >&nbsp;{{'account.yearly' | translate}}
                                        </label>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-6">
                                            <label for="CardName" class="mb-0">{{'account.card_name' | translate}}<span class="error">*</span></label>
                                            <input id="CardName" type="text" formControlName="CardName" class="form-control" maxlength="26" 
                                            [ngClass]="{ 'is-valid': CardName['valid'], 'is-invalid': CardName['invalid'] }"/>
                                            <ng-container *ngIf="buySubscriptionForm.get('CardName').invalid && (formSubmitted || buySubscriptionForm.get('CardName').touched || buySubscriptionForm.get('CardName').dirty)">
                                                <div *ngIf="buySubscriptionForm.get('CardName').hasError('required')" class="error">
                                                    {{'general.required_field' | translate}}
                                                </div>
                                                <div *ngIf="buySubscriptionForm.get('CardName').hasError('pattern')" class="error">
                                                    {{'error.card_name' | translate}}
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="top-bottom">{{'account.card_number' | translate}}<span class="error">*</span></div>
                                            <ngx-stripe-card #card [options]="cardOptions" [elementsOptions]="elementsOptions" (change)="cardUpdated($event)" (error)="error = $event" value=""></ngx-stripe-card>
                                            <div id="stripeError" class="error">
                                            {{error?.message}}
                                            </div>
                                            <br>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <strong>{{'account.billing_address' | translate}}: </strong><br><br>
                                    <div class="row">
                                        <div class="col-12">
                                            <label for="BillingAddress" class="mb-0">{{'user.address' | translate}}<span class="error">*</span></label>
                                            <input id="BillingAddress" type="text" formControlName="BillingAddress" class="form-control" maxlength="100"
                                            [ngClass]="{ 'is-valid': BillingAddress['valid'], 'is-invalid': BillingAddress['invalid'] }"/>
                                            <ng-container *ngIf="buySubscriptionForm.get('BillingAddress').invalid && (formSubmitted || buySubscriptionForm.get('BillingAddress').touched || buySubscriptionForm.get('BillingAddress').dirty)">
                                                <div *ngIf="buySubscriptionForm.get('BillingAddress').hasError('required')" class="error">
                                                    {{'general.required_field' | translate}}
                                                </div>
                                                <div *ngIf="buySubscriptionForm.get('BillingAddress').hasError('pattern')" class="error">
                                                    {{'error.address' | translate}}
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <label for="BillingCity" class="top-bottom">{{'user.city' | translate}}<span class="error">*</span></label>
                                            <input id="BillingCity" type="text" formControlName="BillingCity" class="form-control" maxlength="50"
                                            [ngClass]="{ 'is-valid': BillingCity['valid'], 'is-invalid': BillingCity['invalid'] }"/>
                                            <ng-container *ngIf="buySubscriptionForm.get('BillingCity').invalid && (formSubmitted || buySubscriptionForm.get('BillingCity').touched || buySubscriptionForm.get('BillingCity').dirty)">
                                                <div *ngIf="buySubscriptionForm.get('BillingCity').hasError('required')" class="error">
                                                    {{'general.required_field' | translate}}
                                                </div>
                                                <div *ngIf="buySubscriptionForm.get('BillingCity').hasError('pattern')" class="error">
                                                    {{'error.address' | translate}}
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="col-6">
                                            <label for="BillingState" class="top-bottom">{{'user.state' | translate}}<span class="error">*</span></label>
                                            <input id="BillingState" type="text" formControlName="BillingState" class="form-control" maxlength="50"
                                            [ngClass]="{ 'is-valid': BillingState['valid'], 'is-invalid': BillingState['invalid'] }"/>
                                            <ng-container *ngIf="buySubscriptionForm.get('BillingState').invalid && (formSubmitted || buySubscriptionForm.get('BillingState').touched || buySubscriptionForm.get('BillingState').dirty)">
                                                <div *ngIf="buySubscriptionForm.get('BillingState').hasError('required')" class="error">
                                                    {{'general.required_field' | translate}}
                                                </div>
                                                <div *ngIf="buySubscriptionForm.get('BillingState').hasError('pattern')" class="error">
                                                    {{'error.address' | translate}}
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <label for="BillingCountry" class="top-bottom">{{'user.country' | translate}}<span class="error">*</span></label>
                                            <input id="BillingCountry" type="text" class="form-control" maxlength="100" formControlName = "BillingCountry"
                                            [ngClass]="{ 'is-valid': BillingCountry['valid'], 'is-invalid': BillingCountry['invalid'] }" />
                                            <ng-container *ngIf="buySubscriptionForm.get('BillingCountry').invalid && (formSubmitted || buySubscriptionForm.get('BillingCountry').touched || buySubscriptionForm.get('BillingCountry').dirty)">
                                                <div *ngIf="buySubscriptionForm.get('BillingCountry').hasError('required')" class="error">
                                                    {{'general.required_field' | translate}}
                                                </div>
                                                <div *ngIf="buySubscriptionForm.get('BillingCountry').hasError('pattern')" class="error ta-left">
                                                    {{'error.address' | translate}}
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="col-6">
                                            <label for="BillingZipCode" class="top-bottom">{{'user.zip_code' | translate}}</label>
                                            <input id="BillingZipCode" type="text" class="form-control" maxlength="5" disabled />
                                        </div>
                                    </div>
                            </div>
                            <div *ngIf="cart!=null" class="col-10"></div>
                        </div>
                    </div>
                </div>             
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-2">
                <div class="card border-top-green">
                    <div class="card-body">
                        <h4>{{'account.order_summary' | translate}}</h4>
                        <hr>
                        <h5>
                            <div class="row">
                                <div class="col-6">Subtotal: </div>
                                <div class="col-6 text-right">$ {{(subtotal)?(functionsService.currencyFormat(subtotal)):''}}  USD</div>
                            </div>
                            <div id="tax-row" class="row tax-row">
                                <div class="col-6">Tax (11.5%): </div>
                                <div class="col-6 text-right">$ {{(tax)?(functionsService.currencyFormat(tax)):''}} USD</div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-3">Total: </div>
                                <div class="col-9 text-right"><h3>$ {{(total)?(functionsService.currencyFormat(total)):''}}  USD</h3> <i> {{'account.'+ MorY | translate}}</i></div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-12 small">
                                    <strong>{{'general.important' | translate}}: </strong>{{'account.trial_message' | translate}}
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <input type="submit" class="btn btn-green btn-h-green w-100 ml-2 mr-2" title="{{'account.complete_order' | translate}}" 
                                    value="{{'account.complete_order' | translate}}">
                            </div>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div *ngIf="cart==null">
    <h2 class="page-title" tabindex="0">{{'account.account' | translate}}</h2>
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
          <span *ngIf="breadcrumb">{{ 'account.' + breadcrumb | translate }}</span>
       </ng-container>
   </xng-breadcrumb>
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 p-3">
            <div class="card border-top">
                <div class="card-body">
                    <h4>{{'account.account_information' | translate}}</h4>
                    <hr>
                    <div class="row">
                        <div class="col-12 profile-pic text-center">
                            <img class="img-round" [src]="orgProfile?.logo?orgProfile.logo:'assets/images/company.png'" width="120" height="120" alt="{{orgProfile?.name}}" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-center">
                            <strong>{{orgProfile?.name}}</strong>
                        </div>
                    </div>
                    <div class="row pt-10">
                        <div class="col-6">
                            <i class="fa fa-user"></i>&nbsp;<strong>{{'account.owner' | translate}}:</strong>
                        </div>
                        <div class="col-6">
                            {{orgProfile?.profileFirstName}} {{orgProfile?.profileLastName}}
                        </div>
                    </div>
                    <div class="row pt-10">
                        <div class="col-6">
                            <i class="fa fa-envelope"></i>&nbsp;<strong>{{'general.email' | translate}}:</strong>
                        </div>
                        <div class="col-6">
                            {{email}}
                        </div>
                    </div>
                    <div class="row pt-10">
                        <div class="col-6">
                            <i class="fa fa-phone-alt"></i>&nbsp;<strong>{{'account.owner_phone' | translate}}:</strong>
                        </div>
                        <div class="col-6">
                            {{orgProfile?.profilePhoneNumber}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 p-3">
            <div class="card border-top">
                <div class="card-body">
                    <h4>{{'account.active_subscription' | translate}}</h4>
                    <hr>
                    <div class="row">
                        <div class="col-12 h3 font-weight-light">
                            {{'account.no_subscription' | translate}} <a tabindex="0" class="hyperlink h3" (keydown.enter)="changePlan(false)" (click)="changePlan(false)">{{'account.here' | translate}}</a>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

